<div class="table-responsive" [class.overflow-hidden]="classifiedsMccService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover key-log-list-table footable"
           *ngIf="classifiedsMccService.data.allClassifiedsMcc.data.length">
        <thead>
        <tr [ngClass]="{'noSort': classifiedsMccService.data.allClassifiedsMcc.data.length < 2}">
            <th (click)="orderBy('keyTag', $event)" class="footable-sorted">Title<span class="footable-sort-indicator"></span></th>
            <!--<th *ngIf="classifiedsService.buildings.length > 1"-->
            <!--(click)="orderBy('building.name', $event)">Building<span class="footable-sort-indicator"></span>-->
            <!--</th>-->
            <!--<th (click)="orderBy('suite.suiteNumber', $event)">Unit/Room<span class="footable-sort-indicator"></span></th>-->
            <th>Content</th>
            <th>Start</th>
            <th>End</th>
            <th>Posted By</th>
            <th (click)="orderBy('status', $event)">Status<span class="footable-sort-indicator"></span></th>
            <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <ng-template ngFor let-item [ngForOf]="classifiedsMccService.data.allClassifiedsMcc.data" let-index="index">
            <tr [ngClass]="{'footable-odd': (index % 2 === 0)}">
                <td>{{item.title}}</td>
                <!--<td *ngIf="classifiedsService.buildings.length > 1">{{item.buildingName}}</td>-->
                <td>{{item.content}}</td>
                <td>{{item.activateFrom}}</td>
                <td>{{item.activateTo}}</td>
                <td>{{item.createdBy}}</td>
                <td>
                    <span *ngIf="item.status === 'approved'"  class="text-uppercase label label-picked_up" >Approved</span>
                    <span *ngIf="item.status === 'pending'"  class="text-uppercase label label-received" >Pending</span>
                    <span *ngIf="item.status === 'reject'"  class="text-uppercase label label-picked_up" >Reject</span>
                    <span *ngIf="item.status === 'expired'"  class="text-uppercase label label-received" >Expired</span>
                </td>
                <td class="td-action-btn">
                    <div class="input-group-btn btn-in-table input-group">
                        <button (click)="previewClassified(item)" class="btn btn-white btn-xs sign-out-return-buttons">
                            Preview
                        </button>
                        <button data-toggle="dropdown" class="btn btn-white dropdown-toggle btn-xs"
                                aria-expanded="false"><span class="caret"></span></button>
                        <ul class="dropdown-menu pull-right">
                            <li (click)="editClassified(item)"><a>Edit</a></li>
                            <li (click)="changeClassifiedStatus(item, 'approved')"><a>Approve</a></li>
                            <li (click)="changeClassifiedStatus(item, 'reject')"><a>Reject</a></li>
                            <li (click)="deleteClassified(item)"><a>Delete</a></li>
                        </ul>
                    </div>
                </td>
            </tr>
        </ng-template>
        <tr *ngFor="let item of classifiedsMccService.emptyRowService.emptyRow" style="cursor: default;">
            <td>&nbsp;</td>
            <!--<td *ngIf="classifiedsService.buildings.length > 1"></td>-->
            <td></td><td></td><td></td><td></td><td></td>
        </tr>
        </tbody>
    </table>
    <h2 *ngIf="classifiedsMccService.data.allClassifiedsMcc.total == 0" class="text-center">Result Not Found</h2>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/classifieds-mcc/classifieds-mcc-list/classifieds-mcc-list.component.html